import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazy(() => import('./components/Helmet.tsx')),

  XandrProgrammatic: {
    Overview: lazy(() => import('./containers/XandrProgrammatic/containers/Overview/index.tsx')),
    WebsitesMapping: lazy(() => import('./containers/XandrProgrammatic/containers/WebsitesMapping/index.tsx')),
    BrandsMapping: lazy(() => import('./containers/XandrProgrammatic/containers/BrandsMapping/index.tsx')),
    Deals: lazy(() => import('./containers/XandrProgrammatic/containers/Deals/index.tsx')),
    BuyerMapping: lazyNamed(() => import('./containers/XandrProgrammatic/containers/BuyerMapping/index.tsx'), 'BuyerMapping'),
    Layout: lazy(() => import('./containers/XandrProgrammatic/components/Layout/index.tsx')),
    OverviewRedirect: lazy(() => import('./containers/XandrProgrammatic/components/OverviewRedirect.tsx')),
  },

  GoogleProgrammatic: {
    WebsitesMapping: lazy(() => import('./containers/GoogleProgrammatic/containers/WebsitesMapping/index.tsx')),
    BrandsMapping: lazy(() => import('./containers/GoogleProgrammatic/containers/BrandsMapping/index.tsx')),
    BuyerMapping: lazyNamed(() => import('./containers/GoogleProgrammatic/containers/BuyerMapping/index.tsx'), 'BuyerMapping'),
    Layout: lazy(() => import('./containers/GoogleProgrammatic/Layout.tsx')),
  },

  InvalidTrafficDeductions: lazyNamed(() => import('./containers/InvalidTrafficDeductions/index.tsx'), 'InvalidTrafficDeductions'),

  AdomikProgrammatic: {
    Layout: lazyNamed(() => import('./containers/AdomikProgrammatic/components/Layout.tsx'), 'Layout'),
    WebsiteMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/WebsiteMappings/index.tsx'), 'WebsiteMappings'),
    BrandMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/BrandMappings/index.tsx'), 'BrandMappings'),
    BuyerMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/BuyerMappings/index.tsx'), 'BuyerMappings'),
    Deals: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/Deals/index.tsx'), 'Deals'),
    SSPMappings: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/SSPMappings/index.tsx'), 'SSPMappings'),
    Seats: lazyNamed(() => import('./containers/AdomikProgrammatic/pages/Seats/index.tsx'), 'Seats'),
  },
};
